import { createAsyncThunk } from '@reduxjs/toolkit';
import { directusApi } from '../../api/directus';

export const fetchItems = createAsyncThunk('items/fetchItems', async () => {
    return await directusApi.getTrainers();
});
